package org.multiplatform.kotfolio.pages.kids

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("food")
@Composable
fun KidsFoodPage() {
    BlogLayout(
        PageProperties(
            "Food",
            "" ),
        BlogProperties("Kids", "Food")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Food",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Food is a substance (પદાર્થ) we eat to stay healthy, and strong. It is used to provide nutrition (પોષણ) to the body. Eg: Rice, Dal, Honey etc",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Need Food",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When we are hungry, we feel tired, sleepy and sometimes even angry. We don't feel like playing or doing our homework. But after we eat a meal or a snack, we start to feel better.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We all eat fruits and vegetables, some of us also eat chicken and fish. So, anything that we eat to live is called food. We need food as it helps our bodies to grow, remain healthy, and gives us energy to do work.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Food is like fuel to our body. All living (જીવંત) creatures (જીવો), be it plants and animals, need food to survive. So food is very precious, and must not be wasted.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Protects us from diseases.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Maintains life.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Types of Food",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Raw (કાચું): Food that can be eaten without cooking called raw food. Meat cannot be eaten raw.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cooked (રાંધેલ): ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Source of Food",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Plants",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animals",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "People who eat only plant sources of food are called Vegetarian.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Fruits",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Fruits are sweet and yummy. Different fruits have different tastes - some are sweet and some are sour (ખાટા). Apple, Banana, Orange, Grapes, Watermelon, Cherry, Pear, Strawberry, Pineapple",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Vegetables",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We eat the leaves, stems, roots and flowers of different plants. Vegetables are healthy and help us grow strong. Carrot, Spinach, Tomato, Peas, Spinach, Cabbage, Lettuce, Sugarcane, Potato, Beetroot, Radish, Cauliflower, Broccoli",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Grain (cereals) (અનાજ), Plants and Pulses (કઠોળ - दालें)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We get grains and pulses from some plants. Grains are also called cereals. Rice and wheat are grains, while beans and peas are pulses. Plants also give us oils like mustard, sunflower, or groundnut oil, which is used as a cooking fuel. Plants are a major source of food for both humans and other animals. Grains give u s energy and make us feel full. Rice, Wheat, Bread, Cereals & Pulses, Kidney beans)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Wheat after grinding (પીસ્યા) is used to make chapattis (roti), bread, noodles, etc. Rice is used to make boiled rice, dosas and idlis. Plants are also a source of sugar, spices, tea and the coffee that we drink.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Nutrients",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Carbohydrates, Proteins, Fats, Water, Vitamins and Minerals",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Nuts",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Some plants provide us with nuts such as almonds, pistachios, walnuts, fig, cashew nuts and peanuts (groundnut) (મગફળી). Nuts are good for our health and we should eat a few every day.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Animal",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animals provide us with food materials such as milk, eggs, chicken, meat and fish. Animals like the cow, goat and buffalo give us milk.  Hen, duck provides eggs. Goat, Hen and Fish chickens provide us with meat. Milk from these animals are also extracted, but we usually drink cow or buffalo milk.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Dairy",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dairy foods help keep our bones and teeth strong. Milk, Cheese, Yogurt, Butter",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Sweets",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sweets taste yummy and are fun to eat. Cakes, Candies, Ice-Cream, Sweets",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Healthy Food",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    Different kinds of food
                    
                    Energy giving - gives energy to work - grains, cheese, sugar
                    Body building - help us grow big and strong - pulses, milk, eggs, meat
                    Protective - protect us from diseases - fruits, vegetables
                    """.trimIndent()
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When we are healthy we can study and play. We also do not fall sick. To stay healthy, it is important for us to eat properly. We must eat foods like fruits, vegetables, grains, pulses, milk, meat and eggs to stay healthy. The foods that help us to stay well and remain healthy are called healthy foods.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We must also drink at least 8-10 glasses of water every day.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Some foods such as ice creams, pizza, soft drinks, candies, pastries and chips are not good for our health. The food that is not good for our health is called junk food. We should eat less of junk food and more of healthy food.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Meals in a Day",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We eat three meals every day.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Breakfast - Breakfast is the first meal of the day that we have in the morning.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Lunch - We eat it in the afternoon.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dinner - We eat it in the evening.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The food we eat in between the meals is called snack.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Its 12:30 pm in the afternoon and Anu decides to have her meal. Her plate has rice, dal, pickle and some curd. Which meal is she having? Lunch",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It's 8:00 am in the morning and Rita is having her first meal of the day. She is having tomato sandwiches. Which meal is she having? Breakfast",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Good habit",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Wash our hands before and after eating our meals",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Eat food that has been kept covered.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Chew (ચાવવું) food properly and do not talk with food in our mouth.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Wash fruits and vegetables before cooking and eating them.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should not waste food.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Review",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Plants: Fruits, Nuts, Vegetables, Grain (cereals) (અનાજ), Plants and Pulses (કઠોળ - दालें)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animal: Milk, Eggs, Meat",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flour: Powder made from finely ground dried grains, nuts, seeds, or vegetables,",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Quiz",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We eat food to stay Strong.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            Ol {
                //Drapery, Armoury
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cultery: Forks, spoons, and knives are collectively called which of these?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "chocolate, coffee, caramel, walnut, and cinnamon: Which of these food items is also used to describe a shade of brown?",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Foil made from which of these elements is usually used to wrap food to keep it warm? Aluminum",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which colour does saffron add to a food dish? Yellow (golden-yellow to orange)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }


                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these sweet dishes is made from rice? Kheer",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Suji (also known as rava), or semolina, is usually prepared from which of the following? Wheat",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "According to a popular Hindi proverb, how does the fruit of patience (ધીરજ) taste? Sweer",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these food items is also known in Delhi as 'gol gappa'? Pani Puri",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Generally, which of these is eaten at the end of a meal? Dessert, Soup, Appetizer, Main Course",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these fruits is normally not eaten with the skin? Jackfruit",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which fruit would link Jaffa, China, Nagpur and Valencia? orange",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these is a side dish usually prepared with curd and vegetables? Raita",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these oils, commonly used in cooking, is also known as 'kadua tel'? mustard oil",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "While pouring tea, which of these is usually used to separate tea-leaves? strainer (or sieve)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What is the primary purpose of chopsticks as a device? Eating",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Food from which part of the world is most commonly eaten using 'chopsticks'? Food from East Asia and Southeast Asia, particularly China, Japan, Korea, Vietnam, and Thailand, is most commonly eaten with chopsticks, stemming from the staple of sticky rice and shared dishes, with China alone using billions annually.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these countries is the largest producer of coffee in the world? Brazil",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A museum for what was established by the Tatas in Munnar, Kerala, a place where it is grown widely? Tea, The Tata Group established the Tata Tea Museum (now known as the Kannan Devan Hills Plantation Tea Museum) in Munnar, Kerala, to showcase the history, cultivation, and processing of tea, which is widely grown in the region's vast plantations.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Pasteurisation is a process most popularly associated with what? Milk",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which fruit from Gujarat's Navsari district was awarded a GI tag? Amalsad Chikoo (Sapodilla",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mutton is a key ingredient in which of these food items? Laal Maas",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Chaat masala would usually be used to flavour which of these? Dahi vada",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Murgh masala is a classic Indian curry dish consisting of succulent chicken pieces cooked in a rich, spicy sauce made from a base of onions, tomatoes, yogurt, and a blend of fragrant spices. Chicken",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Indori poha and Ratlami sev are food items from which state? Madhya Pradesh",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which of these has a characteristic clarity due to the use of gelatin while cooking? jelly is a savory gelatinous stock used to coat meats, seafood, or vegetables, and it is highly valued for its crystal clear, transparent appearance.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The name of which of these fruits is also a word meaning 'common' in Hindi? Mango",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mangiferin is a chemical mainly found in which of these? mango",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What term is used for the street food item in which soya is wrapped around a wooden stick to mimic meat? Soya Chaap",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Maida is usually obtained from which of these? Wheat",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Arrange these steps in the correct order to prepare gajar ka halwa. 1. Grate carrots 2. Boil carrots in milk 3. Add ghee 4. Garnish with dry fruits",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}

//What substance gives the neer dosa its name? Food
//jackfruit, the world's largest tree-borne fruit, known for its spiky green rind and stringy, sweet flesh (or savory when unripe) used as a meat substitute, but it can also refer to various restaurants or food businesses using the name, like Jack Food in India or brands like Jackfruit365 for diabetic flour.
//Finger millet is another name for which crop? Ragi
//Which of these food items is usually spiral-shaped? Jalebi
//Which city of Madhya Pradesh gives its name to a spicy fried 'besan-namkeen'? Ratlam snack being known as Ratlami Sev
//Generally, which of these food items has variants such as toast, grilled and club? sandwich
//sizzler
//Orange: vitamin C